var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form-group',{attrs:{"label":_vm.label,"description":_vm.description,"error":_vm.error,"state":_vm.errorState}},[(_vm.readonly)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('b-form-select',{attrs:{"value":_vm.input,"options":_vm.options,"state":_vm.errorState},on:{"input":_vm.handleInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }